import * as angular from 'angular';

import { ComponentDefinition, ApplicationUserViewModel } from '../../models';

class ApplicationUsersTableController implements angular.IComponentController {
    isLoading: boolean;
    users: ApplicationUserViewModel[];
    actions: { icon: string; callback: (vm: ApplicationUserViewModel) => void }[];

    static $inject = [];
    constructor() {
    }

    $onInit() {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {

    }
}

export const wtApplicationUsersTable: ComponentDefinition = {
    componentId: 'wtApplicationUsersTable',
    controller: ApplicationUsersTableController,
    template: require('./applicationUsersTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        users: '<',
        isLoading: '<?',
        actions: '<?'
    }
};
